import { render } from "./OpeningHoursPeriodsDetail.vue?vue&type=template&id=1aaf6686&scoped=true&ts=true"
import script from "./OpeningHoursPeriodsDetail.vue?vue&type=script&lang=ts"
export * from "./OpeningHoursPeriodsDetail.vue?vue&type=script&lang=ts"

import "./OpeningHoursPeriodsDetail.vue?vue&type=style&index=0&id=1aaf6686&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aaf6686"]])

export default __exports__